import {configure, defineRule, ErrorMessage, Field, Form} from 'vee-validate';
import {localize, setLocale} from '@vee-validate/i18n';
import de from '@vee-validate/i18n/dist/locale/de.json';
import val_de from './vee-validate/val_de.json'
import {defineNuxtPlugin} from 'nuxt/app'
import * as rules from '@vee-validate/rules'

const rulesForErrorMessage = [
    'validation_pending'
]

export default defineNuxtPlugin((nuxtApp) => {

    /**************
     * Custom rules
     **************/

    // defineRule('confirm_password', (value, [password]) => value === password);
    rulesForErrorMessage.forEach(rule => defineRule(rule, () => false))


    defineRule('bookingsRequired', (value) => {
        return value > 0
    });

    defineRule('bookingsConflicted', (value) => {
        return !value?.length || !value.some(booking => booking.hasConflicts)
    });

    defineRule('newBookingConflicted', (value) => {
        return !value || !value.hasConflicts
    });

    defineRule('phone', (value) => {
        return /^[0-9+\-/() ]{3,}$/.test(value)
    });

    defineRule('phoneInvalid', () => {
        return false
    });

    defineRule('addressIsIncomplete', (value) => {
        return !!value
    });

    defineRule('ibanInvalid', () => {
        return false
    });

    defineRule('notAuthenticated', () => {
        return false
    });

    defineRule('invoiceRecipient', (value) => {
        return !!value
    });

    defineRule('contactPerson', (value) => {
        return !!value
    });

    defineRule('regexWithMessage', (value, [regex, message]) => {
        if (value.toString().match(regex)) return true
        return message
    });

    defineRule('includes', (value, [text, message]) => {
        if (value.toString().toLowerCase().includes(text.toLowerCase())) return true
        return message ? message : false
    });

    defineRule('isInvalid', () => {
        return false
    });

    /**************
     * Configuration
     **************/

    Object.keys(rules).forEach(rule => {
        if (rule === 'all') return;
        defineRule(rule, rules[rule]);
    });

    setLocale('de');

    nuxtApp.vueApp.component("VField", Field)
    nuxtApp.vueApp.component("VForm", Form)
    nuxtApp.vueApp.component("ErrorMessage", ErrorMessage)

    configure({
        generateMessage: localize({
            de: {...de, messages: {...de.messages, ...val_de.messages}, names: {...de.names, ...val_de.names}}
        }),
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid',
            dirty: ['is-dirty', 'is-dirty'] // multiple classes per flag!
        }
    });
})